import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[680px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center object-top"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=A%20stunning%20artistic%20Korean%20manhwa%20style%20illustration%20featuring%20diverse%20comic%20characters%20in%20dynamic%20poses%2C%20warm%20coral%20and%20gold%20gradient%20background%2C%20floating%20comic%20panels%2C%20vibrant%20energy%2C%20dramatic%20lighting%2C%20modern%20webtoon%20aesthetic%2C%20cinematic%20composition%2C%20rich%20colors%2C%20high%20detail&width=1920&height=900&seq=hero-bg-main&orientation=landscape')`,
        }}
      >
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
            发现你的专属<span className="text-primary-400">韩漫</span>世界
          </h1>
          <p className="text-sm md:text-lg text-background-50/80 max-w-xl mx-auto leading-relaxed mb-8">
            海量正版韩国漫画免费在线阅读，涵盖恋爱、悬疑、奇幻、校园等多种类型，每日同步更新最新章节
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/romance"
              className="bg-primary-500 text-background-50 px-8 py-3 rounded-full text-sm md:text-base font-medium whitespace-nowrap hover:bg-primary-600 transition-all duration-300 cursor-pointer shadow-lg shadow-primary-500/25"
            >
              立即探索
            </Link>
            <Link
              to="/about"
              className="bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 px-8 py-3 rounded-full text-sm md:text-base font-medium whitespace-nowrap hover:bg-background-50/30 transition-all duration-300 cursor-pointer"
            >
              了解更多
            </Link>
          </div>

          <div className="mt-12 flex items-center justify-center gap-8 md:gap-12">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">5000+</p>
              <p className="text-xs md:text-sm text-background-50/60 mt-1">海量漫画</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">每日更新</p>
              <p className="text-xs md:text-sm text-background-50/60 mt-1">同步最新章节</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">全免费</p>
              <p className="text-xs md:text-sm text-background-50/60 mt-1">无需付费</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}